import EmblaCarousel from 'embla-carousel'

document.querySelectorAll('.media-carousel').forEach((carouselEl) => {
  const container = carouselEl.closest('.carousel-container')
  const autoHeight = carouselEl.classList.contains('auto-height')

  const embla = EmblaCarousel(carouselEl, {
    loop: true,
    align: 'center',
    containScroll: false,
    dragFree: false,
    slidesToScroll: 1,
  })

  if (autoHeight) {
    const setHeight = () => {
      const slide = embla.slideNodes()[embla.selectedScrollSnap()]
      if (!slide) return

      // Measure the slide's inner content, not the flex-stretched slide itself
      const content = slide.firstElementChild || slide
      const height = content.getBoundingClientRect().height

      if (height > 0) {
        carouselEl.style.height = `${height}px`
      }
    }

    embla.on('init', setHeight)
    embla.on('reInit', setHeight)
    embla.on('select', setHeight)

    window.addEventListener('resize', setHeight)

    // Images often aren't loaded when init fires → height would be 0
    carouselEl.querySelectorAll('img').forEach((img) => {
      if (img.complete) return
      img.addEventListener('load', setHeight)
      img.addEventListener('error', setHeight)
    })
  }

  // Prev / Next
  container.querySelector('.carousel-previous')?.addEventListener('click', () => embla.scrollPrev())
  container.querySelector('.carousel-next')?.addEventListener('click', () => embla.scrollNext())

  // Dot pagination (unchanged)
  const dotsEl = container.querySelector('.carousel-pagination')
  if (dotsEl) {
    const buildDots = () => {
      dotsEl.innerHTML = embla
        .scrollSnapList()
        .map(
          (_, i) => `
        <button class="carousel-dot${i === embla.selectedScrollSnap() ? ' is-selected' : ''}" data-index="${i}"></button>
      `,
        )
        .join('')

      dotsEl.querySelectorAll('.carousel-dot').forEach((dot) => {
        dot.addEventListener('click', () => embla.scrollTo(Number(dot.dataset.index)))
      })
    }

    const syncDots = () => {
      dotsEl.querySelectorAll('.carousel-dot').forEach((dot, i) => {
        dot.classList.toggle('is-selected', i === embla.selectedScrollSnap())
      })
    }

    embla.on('init', buildDots)
    embla.on('reInit', buildDots)
    embla.on('select', syncDots)
  }
})
